import { autorun, reaction } from 'mobx';
import URI from 'urijs';

import { i18nStore} from '../stores/StoreLoader';
import { ExecutionEnvironment } from "../stores/InterfaceStore";
import {getConfig} from "../_configs/AppConfig";
const {publicRuntimeConfig} = getConfig();

export const getPageInfo = async (url: string) => {
    if (!ExecutionEnvironment.canUseDOM) return;
    if (!window?.FB?.api) {
        setTimeout(() => {
            getPageInfo(url)
        }, 125);
    } else {
        window.FB.api(
            "/oembed_page",
            "get",
            {
                access_token: '',// appId|client access token
                url: url,
                // fields: 'type',
            },
            function (response) {
                if (response && !response.error) {
                    /* handle the result */
                    return response;
                } else {
                    console.log(response.error);
                }
            }
        );
    }
}

export const initFacebookSdk = () => {
    const id = 'fb-root';
    const d = document;
    if (d.getElementById(id)) {
        return;
    }

    const autorunDisposer = autorun(
        () => {
            const fbLocale = i18nStore.facebookCode;
            const appId = publicRuntimeConfig.facebook.appId;
            let current = document.createElement('script');
            current.async = true;
            current.defer = true;
            current.crossOrigin = 'anonymous';
            current.src = `https://connect.facebook.net/${fbLocale}/sdk.js`;
            current.nonce = "CdPtsA4A";
            current.id = `fb-${fbLocale}`;

            const root = d.createElement('div');
            root.id = "fb-root";

            //add new scripts
            const firstChild = d.body.firstChild;
            window.document.body.insertBefore(root, firstChild);
            window.document.body.insertBefore(current, firstChild);

            // init the FB variable again after inserting new script so FB loads all necessary external files.
            current.onload = () => {
                window.FB.init({
                    appId: appId,
                    autoLogAppEvents: false,
                    xfbml: true,
                    version: 'v13.0',
                });
            }
        }
    );

    const reactionDisposer = reaction(() => i18nStore.facebookCode,
        (fbLocale, previousFbLocale) => {
            //remove old scripts
            const previousScript = document.getElementById(`fb-${previousFbLocale}`);
            if (previousScript) window.document.body.removeChild(previousScript);
            const previousRoot = document.getElementById('fb-root');
            if (previousRoot) window.document.body.removeChild(previousRoot);
            if (window.FB) delete window.FB;
        }
    )

    return function() {
        autorunDisposer();
        reactionDisposer();
    }
}

export function isFacebookImageExpired(imageUrl) {
    const queries = URI.parseQuery(imageUrl);
    const hex = queries["oe"];
    const unix = parseInt(hex, 16) * 1000;
    return unix < Date.now();
}
